export default {
    methods: {
        guidanceBadge (status) {
            const map = {
                Approved: 'success',
                Created: 'primary',
                Reviewed: 'purple',
                Certified: 'info',
                Confirmed: 'warning',
                Accepted: 'accepted',
                Rejected: 'danger',
                Unknown: 'rose'
            };

            return map[status] || 'rose';
        },
        guidanceTypeBadge (status) {
            const map = {
                'Per Man Hour': 'info',
                'Per Work Done': 'warning'
            };
            return map[status] || 'rose';
        },

        workplaceBadge (status) {
            const map = {
                Scheduled: 'info',
                Active: 'success',
                Completed: 'rose',
                Cancelled: 'danger',
                Unknown: 'warning'
            };

            return map[status] || 'rose';
        }
    }
};
